/* @ngInject */
const parkIdNewModal = (
  $uibModal,
) => {
  const self = {}

  self.open = async (_wagon) => {
    return $uibModal.open({
      template: require('./parkIdNew.html'),
      resolve: {
        wagon: () => {
          return _wagon
        },
      },
      /* @ngInject */
      controller: (
        $scope,
        $uibModalInstance,
        wagonUtils,
        wagon,
      ) => {
        const id = wagonUtils.idToString(wagon.id)
        const idNew = wagonUtils.idToString(wagon.idNew)
        $scope.text1 = `Le wagon ${id} a été renommé en ${idNew}.`
        $scope.text2 = `Vous allez créer un nouveau wagon avec le numéro ${idNew}. Voulez-vous supprimer le champ "nouveau numéro" du wagon ${id} ?`

        $scope.submit = (rename) => {
          $uibModalInstance.close(rename)
        }

        $scope.cancel = () => {
          $uibModalInstance.close(false)
        }
      },
    })
  }

  return self
}
export default parkIdNewModal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/modals/parkIdNew.modal.js